var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMicOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.969 7.52875C29.969 6.12767 31.1363 5 32.5657 5C33.9952 5 35.1625 6.12767 35.1625 7.52875C35.1625 8.93054 33.9952 10.0575 32.5657 10.0575C31.1363 10.0575 29.969 8.93054 29.969 7.52875ZM29 14.3479C29 12.4262 30.6008 10.8763 32.5657 10.8763C34.5307 10.8763 36.1315 12.4255 36.1315 14.3465V14.5207H29V14.3479Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2494 5H20.2494C16.5466 5 13.5449 8.0017 13.5449 11.7045V21.7612C13.5449 25.464 16.5466 28.4657 20.2494 28.4657H20.2494C23.9522 28.4657 26.9539 25.464 26.9539 21.7612V11.7045C26.9539 8.0017 23.9522 5 20.2494 5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5407 23.015C11.4427 22.3277 10.8893 21.7617 10.1951 21.7617C9.50085 21.7617 8.93065 22.3267 9.00685 23.0167C9.58575 28.2618 13.7499 32.4266 18.9947 33.0064V37.2658H15.2234C14.5291 37.2658 13.9663 37.8286 13.9663 38.5229C13.9663 39.2171 14.5291 39.7799 15.2234 39.7799H25.2801C25.9744 39.7799 26.5372 39.2171 26.5372 38.5229C26.5372 37.8286 25.9744 37.2658 25.2801 37.2658H21.5089V33.0064C26.7536 32.4266 30.9179 28.2618 31.4968 23.0167C31.5729 22.3267 31.0028 21.7617 30.3085 21.7617C29.6142 21.7617 29.0608 22.3277 28.9628 23.015C28.3545 27.2813 24.6862 30.5613 20.2518 30.5613C15.8174 30.5613 12.1491 27.2813 11.5407 23.015Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicOne);
export default __webpack_public_path__ + "static/media/icon_mic_one.df3c61a83642f140136f4bfc1995fbb4.svg";
export { ForwardRef as ReactComponent };